import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BaseComponent } from './../base/base.component';
import { TextboxComponent } from './../textbox/textbox.component';
@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent extends BaseComponent implements OnInit {

  @ViewChild('editbox') editbox: TextboxComponent;

  @ViewChild('selectDropdown') selectDropdown: ElementRef;

  @Input() original: Array<{ id: string, name: string }>;

  @Input() textBoxValue = '';

  @Input() dropdownId: string;

  menuItems: Array<{ id: string, name: string }>;

  @Input() set options(value: Array<{ id: string, name: string }>) {
    this.menuItems = value;
    this.original = value;
    this.selectedIndex = -1;
  }

  @Input() strPlaceholder;

  selectedIndex: number;

  @ViewChild('dropdown') ele: ElementRef;

  @Output() menuItemChanged = new EventEmitter();

  isExpanded: boolean;

  mouseDownHandler: EventListenerObject;

  defaultOption: string;

  constructor(ele: ElementRef) {
    super(ele);
    this.isExpanded = false;
  }

  ngOnInit() {
    this.editbox.setEditable(false);
    this.defaultOption = this.textBoxValue;
  }

  filter(item) {
    return !item.toLowerCase().search(this.toString().toLowerCase()) ||
      this.toString().toLowerCase().startsWith(item.toLowerCase()) || item.indexOf(this) !== -1;
  }

  implementUserInteraction(event) {
  }

  onMenuItemClicked(menuItem: { id: string, name: string }) {
    this.isExpanded = false;
    this.textBoxValue = menuItem.name;
    this.menuItemChanged.emit(menuItem);
  }

  onDropDownArrowClicked() {
    setTimeout(() => {
      this.editbox.setFocus(true);
    }, 10);
  }

  resetDropDownTextBox() {
    this.selectedIndex = -1;
    this.editbox.resetTextBox();
    this.textBoxValue = this.defaultOption;
  }

  hideMenuItems() {
    this.isExpanded = !this.isExpanded;
  }

  setFocus() {
    this.selectDropdown.nativeElement.focus();
  }

  toggleMenuItems() {
    this.isExpanded = !this.isExpanded;
    if (this.isExpanded) {
      this.mouseDownHandler = this.onMouseDown.bind(this);
      window.addEventListener('pointerdown', this.mouseDownHandler);
      window.addEventListener('touchstart', this.mouseDownHandler);
      window.addEventListener('mousedown', this.mouseDownHandler);
    }
  }
  onMouseDown(event) {
    let element: any = event.target;
    const dropDownContainer: HTMLElement = document.getElementById(this.dropdownId + '-container');

    while (element != null) {
      if (element === dropDownContainer) {
        return;
      }
      element = element.offsetParent;
    }
    this.closeSimulatePopup();
    this.isExpanded = false;
  }

  closeSimulatePopup() {
    window.removeEventListener('pointerdown', this.mouseDownHandler);
    window.removeEventListener('touchstart', this.mouseDownHandler);
    window.removeEventListener('mousedown', this.mouseDownHandler);
  }

}

enum DropDownType {
  SELECT = 1,
  EDIT = 2
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/dropdown/dropdown.component.ts